enum LangEnum {
    EN = "en",
    RU = "ru",
}

export default LangEnum;